module.exports = __webpack_public_path__ + "img/personal.c73a3d36.jpg";